class CustomLayoutForBazzar {
	#response = window.orichiQuantityProductRes;
	constructor() {
		this.#response = window.orichiQuantityProductRes;
		this.selectedTier = null;
		this.currentScrollPosition = 0;
		console.log("runnnn");
	}
	init(response) {
		this.#response = response;
		if (
			(!response && !response.Setting2 && !response.Setting2.CardTheme) ||
			(!response &&
				!response.Setting2 &&
				!response.Setting2.LayoutInProductPage) ||
			(response.Rule && response.Rule.length === 0) ||
			!isUsingMultiCurrency
		) {
			console.log("Requirements not met for initialization");
			return;
		}
		this.#renderCard();
	}
	#renderCard() {
		const $quantityInput = o$(".product-form .quantity-selector input");
		if ($quantityInput.length === 0) {
			console.log("Quantity input not found");
			return;
		}

		// Remove existing card if present
		o$(".orichi-card-bazzar").remove();

		const $ocWrap = o$('<div class="orichi-card-bazzar"></div>');
		$quantityInput.closest(".product-form__quantity-wrap").before($ocWrap);

		this.#createCard($ocWrap);

		// Add event listener for quantity change
		$quantityInput.on("change input", () => {
			const quantity = parseInt($quantityInput.val(), 10);
			this.#selectCardByQuantity(quantity);
			this.#updateTotalPrice();
		});
		o$(".quantity-selector .quantity-selector__button").on("click", () => {
			const quantity = parseInt($quantityInput.val(), 10);
			this.#selectCardByQuantity(quantity);
			this.#updateTotalPrice();
		});
	}

	#createCard($container) {
		$container.empty();

		// Create horizontal scrollable container
		const $scrollContainer = o$('<div class="pricing-scroll-container"></div>');

		// Add left arrow
		const $leftArrow = o$(
			'<div class="scroll-arrow scroll-arrow-left"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>'
		);
		$scrollContainer.append($leftArrow);

		// Create cards container
		const $cardsContainer = o$('<div class="pricing-cards-container"></div>');

		this.#response.Rule.forEach((rule, index) => {
			const $tierElement = this.#createTierElement(rule, index);
			$cardsContainer.append($tierElement);
		});

		$scrollContainer.append($cardsContainer);

		// Add right arrow
		const $rightArrow = o$(
			'<div class="scroll-arrow scroll-arrow-right"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>'
		);
		$scrollContainer.append($rightArrow);

		$container.append($scrollContainer);

		// Add scroll event listeners
		this.#setupScrollNavigation($cardsContainer, $leftArrow, $rightArrow);
	}

	#setupScrollNavigation($cardsContainer, $leftArrow, $rightArrow) {
		const scrollAmount = 300; // Adjust based on card width + gap

		$leftArrow.on("click", () => {
			this.currentScrollPosition = Math.max(
				0,
				this.currentScrollPosition - scrollAmount
			);
			$cardsContainer.scrollLeft(this.currentScrollPosition);
			this.#updateArrowVisibility($cardsContainer, $leftArrow, $rightArrow);
		});

		$rightArrow.on("click", () => {
			const maxScroll =
				$cardsContainer[0].scrollWidth - $cardsContainer[0].clientWidth;
			this.currentScrollPosition = Math.min(
				maxScroll,
				this.currentScrollPosition + scrollAmount
			);
			$cardsContainer.scrollLeft(this.currentScrollPosition);
			this.#updateArrowVisibility($cardsContainer, $leftArrow, $rightArrow);
		});

		// Initial arrow visibility
		this.#updateArrowVisibility($cardsContainer, $leftArrow, $rightArrow);

		// Update arrows on scroll
		$cardsContainer.on("scroll", () => {
			this.currentScrollPosition = $cardsContainer.scrollLeft();
			this.#updateArrowVisibility($cardsContainer, $leftArrow, $rightArrow);
		});
	}

	#updateArrowVisibility($cardsContainer, $leftArrow, $rightArrow) {
		const scrollLeft = $cardsContainer.scrollLeft();
		const maxScroll =
			$cardsContainer[0].scrollWidth - $cardsContainer[0].clientWidth;

		// Show/hide left arrow
		if (scrollLeft <= 0) {
			$leftArrow.addClass("hidden");
		} else {
			$leftArrow.removeClass("hidden");
		}

		// Show/hide right arrow
		if (scrollLeft >= maxScroll) {
			$rightArrow.addClass("hidden");
		} else {
			$rightArrow.removeClass("hidden");
		}
	}

	#selectCardByQuantity(quantity) {
		const rules = this.#response.Rule;
		let selectedIndex = -1;
		for (let i = 0; i < rules.length; i++) {
			const start = rules[i].Quantity;
			let end;
			if (i < rules.length - 1) {
				end = rules[i + 1].Quantity - 1;
			} else {
				end = Infinity;
			}
			if (quantity >= start && quantity <= end) {
				selectedIndex = i;
				break;
			}
		}
		if (selectedIndex !== -1) {
			this.selectTierByIndex(selectedIndex);
		}
	}

	#createTierElement(rule, index) {
		const quantityRange = this.#getQuantityRange(rule, index);
		const discountPrice = this.#getPriceByType(rule);
		const valueSave = this.#getValueSave(rule);

		const $tier = o$(`
                    <div class="pricing-tier" data-index="${index}">
                        <div class="tier-quantity">BUY ${quantityRange}</div>
                        <div class="tier-price">${ShopifyFormatMoney(
													discountPrice,
													this.#response.Currency
												)}</div>
                        ${
													rule.PercentOrPrice > 0
														? `<div class="tier-savings">SAVE ${valueSave}</div>`
														: ""
												}
                    </div>
                `);

		$tier.on("click", () => {
			this.#selectTier($tier, rule, index);

			const $quantityInput = o$(".product-form .quantity-selector input");
			$quantityInput.val(rule.Quantity).trigger("change");
			this.#updateTotalPrice();
		});

		return $tier;
	}

	#getQuantityRange(rule, index) {
		const rules = this.#response.Rule;
		const currentQuantity = rule.Quantity;
		if (rule.DiscountType === 4) {
			if (index < rules.length - 1) {
				const nextQuantity = rules[index + 1].Quantity;
				return `${ShopifyFormatMoney(
					currentQuantity * 100,
					this.#response.Currency
				)} - ${ShopifyFormatMoney(
					(nextQuantity - 1) * 100,
					this.#response.Currency
				)}`;
			} else {
				return `${ShopifyFormatMoney(
					currentQuantity * 100,
					this.#response.Currency
				)}+`;
			}
		} else {
			if (index < rules.length - 1) {
				const nextQuantity = rules[index + 1].Quantity;
				return `${currentQuantity}-${nextQuantity - 1}`;
			} else {
				return `${currentQuantity}+`;
			}
		}
	}

	#selectTier($element, rule, index) {
		// Remove previous selection
		o$(".pricing-tier").removeClass("selected");

		// Add selection to clicked tier
		$element.addClass("selected");
		this.selectedTier = { rule, index };

		// Update selected info
		this.#updateSelectedInfo(rule);

		// Trigger custom event for integration
		o$(document).trigger("tierSelected", [{ rule, index }]);
	}

	#updateSelectedInfo(rule) {
		const $selectedInfo = o$("#selectedInfo");
		const $selectedDetails = o$("#selectedDetails");

		if ($selectedInfo.length && $selectedDetails.length) {
			$selectedInfo.show();

			const savings =
				rule.PercentOrPrice > 0 ? ` (Save ${rule.PercentOrPrice}%)` : "";
			$selectedDetails.text(
				`Quantity: ${rule.quantity} • Price: 12312323/YD${savings}`
			);
		}
	}
	#updateTotalPrice() {
		const price = parseInt(this.#response.Price.toFixed(0));
		const $quantityInput = o$(".product-form .quantity-selector input");
		const quantity = parseInt($quantityInput.val(), 10);

		// Kiểm tra xem quantity hiện tại có nằm trong khoảng của rule nào không
		let applicableRule = null;
		for (let i = 0; i < this.#response.Rule.length; i++) {
			const rule = this.#response.Rule[i];
			const start = rule.Quantity;
			let end;
			if (i < this.#response.Rule.length - 1) {
				end = this.#response.Rule[i + 1].Quantity - 1;
			} else {
				end = Infinity;
			}

			if (quantity >= start && quantity <= end) {
				applicableRule = rule;
				break;
			}
		}

		let discountPercent = 0;
		let tier =
			this.selectedTier && this.selectedTier.rule
				? this.selectedTier.rule
				: null;

		// Chỉ áp dụng discount nếu có rule phù hợp
		if (applicableRule && tier && tier.PercentOrPrice > 0) {
			discountPercent = tier.PercentOrPrice;
		}

		const discountPrice = this.#getPriceByType(tier);
		const totalPriceDiscounted =
			discountPercent > 0
				? Math.round(discountPrice * quantity)
				: price * quantity;

		o$(".tiered-pricing-savings.orichi-card-price").remove();

		// Chỉ hiển thị pricing-savings khi có rule phù hợp và có discount
		console.log("🚀 Untitled-1:296 - applicableRule:", applicableRule);
		console.log("🚀 Untitled-1:297 - discountPercent:", discountPercent);
		if (applicableRule && discountPercent > 0) {
			const pricingSaving =
				o$(`<div class='tiered-pricing-savings orichi-card-price'>
        <p class='price-total'>Total: ${ShopifyFormatMoney(
					totalPriceDiscounted,
					this.#response.Currency
				)}</p>
        <p class="price-message" id="volumeDiscountMessage">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 20"><path fill="#eb7602" d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"></path></svg>
          <span class="volumePricePercentSavings">${discountPercent}</span>% volume discount applied
        </p>
      </div>`);

			o$(".product-form__quantity .product-form__quantity-wrap").append(pricingSaving);
		}
	}

	#getPriceByType(rule) {
		const price = parseInt(this.#response.Price.toFixed(0));
		if (!rule) {
			return price * 100; // Return original price if no rule is provided
		}

		switch (rule.PriceType) {
			case 1:
				return (price - (price * rule.PercentOrPrice) / 100) * 100;
			case 2:
				return (price - rule.PercentOrPrice) * 100;
			case 3:
				return rule.PercentOrPrice * 100;
			default:
				return price * 100;
		}
	}
	#getValueSave(rule) {
		const price = parseInt(this.#response.Price.toFixed(0));

		switch (rule.PriceType) {
			case 1:
				return `${rule.PercentOrPrice}%`;
			case 2:
				return ShopifyFormatMoney(
					rule.PercentOrPrice * 100,
					this.#response.Currency
				);
			case 3:
				return ShopifyFormatMoney(
					(price - rule.PercentOrPrice) * 100,
					this.#response.Currency
				);
			default:
				return p`${rule.PercentOrPrice}%`;
		}
	}

	selectTierByIndex(index) {
		const $tierElement = o$(`.pricing-tier[data-index="${index}"]`);
		if ($tierElement.length && this.#response.Rule[index]) {
			this.#selectTier($tierElement, this.#response.Rule[index], index);
		}
	}
}
